import {
    OKTA_AUTH_STARTED,
    OKTA_AUTH_SUCCESS,
    OKTA_AUTH_FAILURE,
    CLEAR_HISTORY_SUCCESS,
    UPDATE_DISCLAIMER_STATUS
  } from '../constants/auth.constant';
  
  const initialState = {
    loading: false,
    loggedUserInfo: {},
    termsInfo: { isLoading: false, isAccepted: false },
    error: null
  };
  
  export default function todosReducer(state = initialState, action) {
    switch (action.type) {
      case OKTA_AUTH_STARTED:
        return {
          ...state,
          loading: true
        };
      case OKTA_AUTH_SUCCESS:
        return {
          ...state,
          loading: false,
          error: null,
          loggedUserInfo: {...state.loggedUserInfo, ...action.payload },
          termsInfo: {
            ...state.termsInfo,
            isLoading: false,
            isAccepted: !action.payload.is_firstlogin
          }
        };
      case OKTA_AUTH_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload.error
        };
      case UPDATE_DISCLAIMER_STATUS:
        return {
          ...state,
          termsInfo: {
            ...state.termsInfo,
            ...action.payload
          }
        };
      default:
        return state;
    }
  }